module.exports = __webpack_public_path__ + "static/media/wightPants.1c3fe79a.jpg";